export const blockIconsDeviceCreditScore = (
	<span className='material-symbols-outlined'>credit_score</span>
);
